const tab_sections = {
    identity: 'Identity',
    integrations: 'Connections',
    login_security: 'Sign-in & security',
    permissions: 'Permissions',
    automation: 'Automation',
    platform: 'Platform',
    overview: 'Overview',
    authentication: 'Authentication',
    authorization: 'Authorization',
    users: 'Users',
    developer: 'Developer',
    tenant: 'Tenant',
};
export default Object.freeze(tab_sections);
